import { Scroller, Slider, Overlay, Buttons, PaginationFraction } from '@cian/slider';

import { FC, ReactNode } from 'react';
import { CarouselWrapper } from './components/CarouselWrapper';

interface ICarouselProps {
  slides: ReactNode[];
}

export const Carousel: FC<ICarouselProps> = ({ slides }) => {
  return (
    <CarouselWrapper>
      <Slider loop>
        <Scroller>{slides}</Scroller>
        {slides.length > 1 && (
          <Overlay>
            <Buttons />
            <PaginationFraction />
          </Overlay>
        )}
      </Slider>
    </CarouselWrapper>
  );
};
